import React, { Component, Fragment } from 'react';
import StreamTDSScriptTitle from './StreamTDSScriptTitle';
import StreamTDSDefaultStream from './StreamTDSDefaultStream';
import StreamTDSScriptOption from './StreamTDSScriptOption';
import Card from '../Card/Card';
import { Row, Col, Button } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';

class StreamTDSScriptMain extends Component {
  render() {
    const {
      onChangeScriptTitle,
      scripts,
      settingsTDS,
      errors,
      defaultStreams,
      onSelectScriptDefaultStreamChange,
      onSelectScriptOptionType,
      onRemoveScript,
      onAddScript,
      onAddNewScriptOption,
      deleteScriptOption,
      onChangeScriptOptionValue,
      getFlowsInfo,
      offers,
      flowsInfo,
      offersInfo,
      saveRef,
      notFoundOffersInStreams,
      setFlowInfo,
      getOffersInfo,
    } = this.props;
    return (
      <Fragment>
        <Card.Header>
          <FMessage id="streamTDS.scripts.header"/>
        </Card.Header>
        {
            scripts && scripts.length > 0 && scripts.map((script, scrKey) =>
              <Card.Body
                key={`option_${scrKey}`}
                className='stream-tds-script-main'>
                <Row>
                  <Col lg="6" xs='10'>
                    <StreamTDSScriptTitle
                      title={script.t}
                      onChangeScriptTitle={onChangeScriptTitle}
                      errors={errors}
                      scrKey={scrKey}
                      errorPath='scriptsTitlesErrors'
                      saveRef={saveRef}
                    />
                  </Col>
                </Row>
                <StreamTDSDefaultStream
                  errors={errors}
                  changePath='r'
                  defaultStreams={defaultStreams}
                  onSelectChange={(prop, value) => onSelectScriptDefaultStreamChange(scrKey, value)}
                  flow={+script.r}
                  inScripts={true}
                  offers={offers}
                  getFlowsInfo={getFlowsInfo}
                  flowsInfo={flowsInfo}
                  offersInfo={offersInfo}
                  scrKey={scrKey}
                  errorPath='defaultStreamsErrors'
                  saveRef={saveRef}
                  notFoundOffersInStreams={notFoundOffersInStreams}
                  scripts={scripts}
                  setFlowInfo={setFlowInfo}
                  getOffersInfo={getOffersInfo}
                />
                {
                  (script.s && script.s.length > 0) ?
                    script.s.map((scriptOption, optKey) =>
                      <StreamTDSScriptOption
                        errors={errors}
                        key={`option_type_${scrKey}_${optKey}`}
                        scrKey={scrKey}
                        optKey={optKey}
                        script={script}
                        scriptOptionsLength={script.s.length}
                        settingsTDS={settingsTDS}
                        allSettingsTDS={settingsTDS}
                        scriptOption={scriptOption}
                        onSelectScriptOptionType={onSelectScriptOptionType}
                        deleteScriptOption={deleteScriptOption}
                        onChangeScriptOptionValue={onChangeScriptOptionValue}
                        saveRef={saveRef}
                      />
                    ) : null
                }
                <Row>
                  <Col lg="12" className='stream-tds-script-controls'>
                    <Button
                      type="button"
                      color="primary"
                      size="sm"
                      outline
                      onClick={() => onAddNewScriptOption(scrKey)}
                    >
                      <FMessage id="streamTDS.buttons.add-scripts-option"/>
                    </Button>
                    {scripts.length > 1 ?
                      <Button
                        type="button"
                        color="light"
                        size="sm"
                        outline
                        onClick={() => onRemoveScript(scrKey)}
                      >
                        <FMessage id="streamTDS.buttons.remove-scripts-group"/>
                      </Button>
                      :
                      null
                    }
                  </Col>
                </Row>
              </Card.Body>
            )
        }
        <Card.Body className='stream-tds-script-add'>
          <Row>
            <Button
              type="button"
              color="primary"
              size="sm"
              outline
              onClick={onAddScript}
            >
              <FMessage id="streamTDS.buttons.add-scripts-group"/>
            </Button>
          </Row>
        </Card.Body>
      </Fragment>
    );
  }
}

export default StreamTDSScriptMain;
